module.exports = __webpack_public_path__ + "static/media/banner.109c24c7.png";